<div class="d-flex flex-column">
  <p-treeSelect
    class="w-20"
    containerStyleClass="w-100"
    [options]="configData.data"
    [selectionMode]="selectionMode"
    [placeholder]="configData.placeholder"
    [(ngModel)]="configData.selectedItems"
    [filter]="filter"
    (onNodeUnselect)="onNodeChange()"
    (onNodeSelect)="onNodeChange()"
    [required]="isRequiredField"
    [formControl]="treeSelectFormControl"
    [ngClass]="{ 'ng-dirty ng-invalid': hasError }"
    [ariaLabel]="configData.ariaLabel"
    nrTreeselectAieaProp
    [ariaRequired]="isRequiredField"
  >
    <ng-template
      let-node
      pTemplate="default"
    >
      {{ node.label }}
    </ng-template>

    <ng-template
      let-node
      pTemplate="value"
    >
      {{ (node | nrTreeSelectSelectedItems: viewSelectedCount) || configData.placeholder }}
    </ng-template>
  </p-treeSelect>
</div>
